// Komunikat po akcji: jeden naraz, wyświetla go komponent Notice zamontowany w layoucie.
const listeners = new Set()

// Domyślny czas wyświetlania komunikatu (ms).
export const NOTICE_MS = 4000

// options: { action: { label, href, name, button, onClick }, opener, ms, stack } — opener to element, na który wraca fokus;
// akcja bez href (z onClick) jest przyciskiem (np. „Cofnij”); ms — czas wyświetlania; stack — akcja pod tekstem
// Zwraca false, gdy na stronie nie ma komponentu Notice.
export function notify (message, options = {}) {
    if (!listeners.size) return false
    listeners.forEach(fn => fn({ message, ...options, at: Date.now() }))
    return true
}

export function subscribeNotice (fn) {
    listeners.add(fn)
    return () => listeners.delete(fn)
}

// Komunikat na następną stronę: przetrwa przeładowanie przy przejściu między routerami; pokazuje go Notice po zmianie ścieżki.
const PENDING_KEY = 'spl:komunikat'
const PENDING_TTL = 15000
// strony, które tylko przekierowują dalej — komunikat czeka na następną
const TRANSIT = ['/konto/login-spolecznosciowy']

// options.keep: nie zastępuje komunikatu zapisanego wcześniej (np. przez stronę przed przekierowaniem)
// options.only: ścieżki, na których komunikat ma się pokazać (na innych jest odrzucany)
export function notifyAfterNavigation (message, options = {}) {
    try {
        if (options.keep && fresh(sessionStorage.getItem(PENDING_KEY))) return true
        sessionStorage.setItem(PENDING_KEY, JSON.stringify({ message, action: options.action, at: Date.now(), from: location.pathname, only: options.only }))
        return true
    } catch (err) {
        return notify(message, options)
    }
}

function fresh (raw) {
    try { return raw && Date.now() - JSON.parse(raw).at < PENDING_TTL } catch (err) { return false }
}

export function takePendingNotice () {
    try {
        const raw = sessionStorage.getItem(PENDING_KEY)
        if (!raw) return null
        const data = JSON.parse(raw)
        if (data?.from === location.pathname || TRANSIT.includes(location.pathname)) return null
        sessionStorage.removeItem(PENDING_KEY)
        if (Array.isArray(data?.only) && !data.only.includes(location.pathname)) return null
        return data && Date.now() - data.at < PENDING_TTL ? { message: data.message, action: data.action } : null
    } catch (err) {
        return null
    }
}
